import { __rest } from 'tslib';
import React from 'react';
import { Size } from '../../../styles/theme.mjs';
import StyledLink from '../../Basic/Link/Link.mjs';
import { StyledProgressButton, StyledProgress, StyledChildrenContainer } from './ProgressButton.styles.mjs';

const ProgressButtonRenderer = (_a) => {
    var { ariaLabel, size = Size.Regular, playNextAfter = 7000, children } = _a, rest = __rest(_a, ["ariaLabel", "size", "playNextAfter", "children"]);
    return (React.createElement(StyledProgressButton, Object.assign({ size: size, "aria-label": ariaLabel }, rest),
        React.createElement(StyledProgress, { playNextAfter: playNextAfter }),
        React.createElement(StyledChildrenContainer, { size: size }, children)));
};
const ProgressButton = (_a) => {
    var { href } = _a, props = __rest(_a, ["href"]);
    if (href) {
        return (React.createElement(StyledLink, { href: href },
            React.createElement(ProgressButtonRenderer, Object.assign({}, props))));
    }
    return React.createElement(ProgressButtonRenderer, Object.assign({}, props));
};

export { ProgressButton, ProgressButton as default };
//# sourceMappingURL=ProgressButton.mjs.map
